// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"82":"post.index","177":"home","336":"post.create","341":"post.edit"}[chunkId] + "." + {"82":"d21acbab","177":"6a6848b2","336":"2172dc56","341":"02986b25"}[chunkId] + ".js";
};